var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasRequired)?_c('router-link',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"to":_vm.to,"target":"_blank"}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")]):_c('button',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"disabled":""}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }